import React, { Component } from 'react';
import { translate } from 'react-i18next';

import HelpLayout from 'components/HelpLayout/HelpLayout';

class Help extends Component {

  render() {
    return (
      <div className='app-container'>
        <HelpLayout history={this.props.history} />
      </div>
    );
  }
}

export default translate()(Help);
